import ComponentsFactory from '../../js/components-factory';
import Cookies from './js/cookie.compoment';

ComponentsFactory.getInstance().define('cookies', Cookies);
